/** @jsx isolateComponent */

import { MessageBar } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Margin } from '@zapier/design-system';

type CurrencyChargeWarningBarProps = {
  /** The margin to apply to the outside of the component. */
  margin?: string;
  selectedCurrencyCode: string;
};

/**
 * A warning bar that tells the user that their actual price may vary based on exchange rate
 */
export const CurrencyChargeWarningBar = ({
  margin = '0',
  selectedCurrencyCode,
}: CurrencyChargeWarningBarProps) => (
  <Margin margin={margin}>
    <MessageBar borderRadius="large" hideIcon={true} title="Note:" type="info">
      Actual price may vary based on the exchange rate in place between USD and{' '}
      {selectedCurrencyCode} at the time of payment processing or invoicing.
      Prices exclude all taxes, levies and duties.
    </MessageBar>
  </Margin>
);
